import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FiFilter } from "react-icons/fi";
import CategoryFilterMenu from "./CategoryFilterMenu";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useDispatch, useSelector } from "react-redux";
import { getAllCreators } from "../../redux/actions/mindfulness";
import { CircularProgress } from "@mui/material";

// Main Container
const PageContainer = styled.div`
  min-height: 100vh;
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;
  margin-top: 6.25rem;
  font-weight: 400;
  /* border-radius: 15px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1); */
  font-family: Montserrat;
`;

const DashboardLink = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #666;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    color: #333;
  }

  &::before {
    content: "←";
    margin-right: 5px;
  }
`;

const ExpertDirectoryContainer = styled.div`
  background-color: white;
  width: 80%;

  border-radius: 15px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
  padding: 1.875rem;
  margin: 0 auto;
`;

const Header = styled.div`
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px 0;
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 14px;
  margin: 0;
`;

const SearchBarContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
  flex-wrap: wrap;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 300px;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: #999;
  }

  &:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

const FiltersButton = styled.button`
  background-color: #ed1e24;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background-color 0.2s;
  display: flex;

  &:hover {
    background-color: #c1121f;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

const ResultsInfo = styled.div`
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;

  span {
    color: #e63946;
    font-weight: 600;
  }
`;

const ExpertsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20%, 1fr));
  gap: 1.5rem;
`;

const ExpertCard = styled.div`
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  min-height: 350px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 0.5rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  border-radius: 10px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  background: rgba(255, 255, 255, 1);
`;

const ProfileImage = styled.div`
  width: 7.5rem;
  height: 7.5rem;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 15px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ExpertName = styled.h3`
  font-size: 1.125rem;
  font-weight: 400;
  color: #0a0a0a;
  margin: 0 0 5px 0;
  text-transform: capitalize;
`;

const ExpertTitle = styled.p`
  font-size: 0.875rem;
  color: #4a5565;
  margin: 0 0 5px 0;
`;

const Experience = styled.p`
  font-size: 0.875rem;
  color: #6a7282;
  margin: 0 0 15px 0;
`;

const Languages = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 10px 0;
`;

const TagsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 15px;
  flex-wrap: wrap;
`;

const Tag = styled.span`
  background-color: #fef2f2;
  color: #ed1e24;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 400;
`;

const BookButton = styled.button`
  width: 100%;
  background-color: #ed1e24;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 10px 0;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: auto;

  &:hover {
    background-color: #c1121f;
  }
`;

const LoaderWrapper = styled.div`
  margin-top: 25%;
  text-align: center;
`;


const ExpertDirectoryPage = () => {
  const experts = useSelector((state) => state?.mindfulness?.creators) || [];

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredExperts, setFilteredExperts] = useState(experts);

  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();
  const dispatch = useDispatch();

  // Function to handle search
  const handleSearch = (term) => {
    setSearchTerm(term);

    if (!term.trim()) {
      setFilteredExperts(experts);
      return;
    }

    const filtered = experts.filter((expert) => {
      const lowerCaseTerm = term.toLowerCase().trim();

      // Check if search term matches any of these fields
      return (
        expert.name.toLowerCase().includes(lowerCaseTerm) ||
        expert.title.toLowerCase().includes(lowerCaseTerm) ||
        expert.tags.some((tag) => tag.toLowerCase().includes(lowerCaseTerm)) ||
        expert.languages.some((lang) =>
          lang.toLowerCase().includes(lowerCaseTerm)
        )
      );
    });

    setFilteredExperts(filtered);
  };

  const handleFilter = (term) => {
    if (term.trim().toLowerCase() === "all") {
      setFilteredExperts(experts);
      return;
    }

    const filtered = experts.filter((expert) => {
      const lowerCaseTerm = term.toLowerCase().trim();

      // Check if search term matches any of these fields
      return (
        expert.name.toLowerCase().includes(lowerCaseTerm) ||
        expert.professional_title.toLowerCase().includes(lowerCaseTerm)
        // expert.tags.some((tag) => tag.toLowerCase().includes(lowerCaseTerm)) ||
        // expert.languages.some((lang) =>
        //   lang.toLowerCase().includes(lowerCaseTerm)
        // )
      );
    });

    setFilteredExperts(filtered);
  };

  // Debounce search to prevent excessive filtering
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      handleSearch(searchTerm);
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  useEffect(async () => {
    await dispatch(getAllCreators());
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setFilteredExperts(experts);
  }, [experts]);

  console.log("Experts", experts, isLoading);

  if (isLoading) {
    return (
      <LoaderWrapper>
        <CircularProgress sx={{ color: "#ED1E24" }} size={50} />
      </LoaderWrapper>
    );
  }

  return (
    <PageContainer>
      {/* <DashboardLink>Dashboard</DashboardLink> */}

      <ExpertDirectoryContainer>
        <Header>
          <Title>Expert Directory</Title>
          <Subtitle>Connect with verified mental health professionals</Subtitle>
        </Header>

        <SearchBarContainer>
          <SearchInput
            type="text"
            placeholder="Search by name, specialization, or category..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {/* <FiltersButton>
            {" "}
            <FiFilter /> Filters{" "}
          </FiltersButton> */}
          <CategoryFilterMenu
            onApplyFilters={(selectedCategory) => {
              console.log("Selected category:", selectedCategory);
              handleFilter(selectedCategory);
            }}
          />
        </SearchBarContainer>

        <ResultsInfo>
          Showing <span>{filteredExperts.length}</span> experts
          {searchTerm && ` matching "${searchTerm}"`}
        </ResultsInfo>

        <ExpertsGrid>
          {filteredExperts.map((expert) => (
            <ExpertCard key={expert.id}>
              <ProfileImage>
                <img src={expert.profile_pic} alt={expert.name} />
              </ProfileImage>
              <ExpertName>{expert.name}</ExpertName>
              <ExpertTitle>{expert.professional_title}</ExpertTitle>
              <Experience>{`${expert.experience_years}+ years of experience`}</Experience>
              {/* <Languages>Languages: {expert.languages.join(", ")}</Languages> */}
              <Languages>Languages: {expert.language_known}</Languages>
              {/* <TagsContainer>
                {expert.tags.map((tag, index) => (
                  <Tag key={index}>{tag}</Tag>
                ))}
              </TagsContainer> */}
              <TagsContainer>
                {expert.specialization.length > 0
                  ? expert.specialization.map((spec, index) => (
                      <Tag key={spec.id || index}>{spec?.name}</Tag>
                    ))
                  : ""}
              </TagsContainer>
              <BookButton
                onClick={() => {
                  history.push({
                    pathname: `/creator_profile`,
                    state: {
                      data: expert
                    },
                  });
                }}
              >
                Book Session
              </BookButton>
            </ExpertCard>
          ))}
        </ExpertsGrid>

        {filteredExperts.length === 0 && searchTerm && (
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            No experts found matching "{searchTerm}". Try a different search
            term.
          </div>
        )}
      </ExpertDirectoryContainer>
    </PageContainer>
  );
};

export default ExpertDirectoryPage;
